import React, { useEffect, useState } from 'react';

import { pendingLeavesApprovals , approveRejectLeave} from '../../../../../API/API';
import classes from './NotifTabs.module.scss';

import { toast } from 'react-hot-toast';

const AppliedLeave = ({ handleChange }) => {
    const [tableData, setTableData] = useState([]);
    const [dataChange, setDataChange] = useState(0);

    const data = JSON.parse(localStorage.getItem('data'));
    const userID = localStorage.getItem('userID');

    useEffect(() => {
        if (data && userID) {
            pendingLeavesApprovals(userID, data.empid, data.token)
                .then(response => {
                    setTableData(response.data)
                    setDataChange(0)
                })
        }
    }, [dataChange])

    console.log(tableData)
    const approve = (id) => {
        if(userID !==null && data !==null){
            approveRejectLeave(userID,data.empid,data.token,id,'A')
            .then(response=>{   
                if(response.data.value==='success'){
                    setDataChange(1)
                    toast.success("Leave has been Approved",{
                        duration:4500
                    });
                }
            })
        }
    }

    const reject = (id) => {
        if(userID !==null && data !==null){
            approveRejectLeave(userID,data.empid,data.token,id,'R')
            .then(response=>{                
                if(response.data.value==='success'){
                    setDataChange(1)
                    toast.success("Leave has been Rejected",{
                        duration:4500
                    });
                }
            })
        }
    }

    return (
        <div>
            <div>
                {tableData !== null && tableData.length > 0 ? tableData.map((item, index) => {
                    return (

                        <div className={classes[`ManualAttDivs`]} key={index}>
                            <div className={classes.NameDesig}>
                                <p><b>Name: </b>{item.applicant.split(',')[0]}</p>
                                <p><b>Designation: </b>{item.applicant.split(',')[1]}</p>
                                <p><b>Applied Date:</b> {item.created} </p>
                            </div>
                            <div className={classes.TimingInfo}>
                                <div className={classes.Info}>
                                    <p><b>From Date:</b> <br />{item.date_from}</p>
                                    <p><b>Total Days:</b> {item.days}<br /> </p>
                                </div>
                                <div className={classes.Info}>
                                    <p><b>Till Date:</b> <br />{item.date_to}</p>
                                    <p><b>Leave Type:</b> {item.leave_type}<br /> </p>
                                </div>
                            </div>
                            <div>
                                <p><b>Location:</b> {item.location}</p>
                                <p><b>Remarks:</b> {item.remarks}</p>
                            </div>
                            <div className={classes.Buttons}>
                                <button onClick={() => { approve(item.id) }}>APPROVE</button>
                                <button onClick={() => { reject(item.id) }}>REJECT</button>
                            </div>
                        </div>

                    )
                }) : <h4 style={{ marginTop: "20px", textAlign: "center" }}> No Leave Approvals To show</h4>}
            </div>
        </div>
    )
}

export default AppliedLeave
